import { LogActions } from './actions'
import { LogGetters } from './getters'
import { LogMutations } from './mutations'
import { LogState } from './state'

export const LOG_NAMESPACE = 'log'

export const Log = {
  namespaced: true,
  state: LogState,
  actions: LogActions,
  mutations: LogMutations,
  getters: LogGetters,
}
